// Library Methods
import { useContext, useMemo } from "react";

// Components
import Grid from "@mui/material/Grid";
import MultiExamReportHeader from "./MultiExamReportHeader/MultiExamReportHeader";
import ReportSections from "src/components/containers/shared/ReportSections/ReportSections";

// Utils
import { isMultiExamPackage } from "src/utils/exams/examReportsHelper";

// Contexts
import { ReportContext } from "src/contexts/reports/ReportContext";

// Types
import { ExamCardSectionNameType } from "src/constants/enums";

const CompleteExamReports = () => {
  const { exam, reportData } = useContext(ReportContext);

  const sortedReportSections = useMemo(() => {
    if (exam) {
      const examSectionNames = Object.keys(exam).filter((key) =>
        key.includes("Sections")
      ) as Array<ExamCardSectionNameType>;

      const reportSections = examSectionNames
        ?.map((sectionName) => Object.values(reportData[sectionName] ?? {}))
        ?.flat()
        ?.sort((a, b) => a.groupId - b.groupId);

      return reportSections;
    }

    return [];
  }, [exam, reportData]);

  const isMultiPackage = useMemo(
    () => Boolean(exam && isMultiExamPackage(exam)),
    [exam]
  );

  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        minWidth: "100%",
      }}
    >
      {isMultiPackage && <MultiExamReportHeader />}

      {sortedReportSections.map((reportSection) => {
        if (!reportSection?.display) {
          return null;
        }

        const key = reportSection?.sectionId ?? reportSection?.sectionId2;

        return (
          <div key={key} style={{ width: "100%" }}>
            <ReportSections
              sectionName={reportSection.sectionName}
              groupId={reportSection?.groupId}
            />
          </div>
        );
      })}
    </Grid>
  );
};

export default CompleteExamReports;
